

/**
 * @class
 * ApiKey model
 */
export default class ApiKey {

    /**
     * @constructor
     * @param {String} name Api key name
     * @param {string} value Api key value
     * @param {Date} createTimestamp Api key create timestamp
     * @param {Boolean} enabled Api key status
     * @param {Date} updateTimestamp Api key update status timestamp
     */
    constructor(
      name,
      value,
      createTimestamp,
      enabled,
      updateTimestamp
    ){ 
      this._name = name
      this._value = value
      this._createTimestamp = createTimestamp
      this._enabled = enabled
      this._updateTimestamp = updateTimestamp
    }

    get name(){
      return this._name
    }
    set name(name){
      this._name = name
    }

    get value(){
        return this._value
    }
    set value(value){
        this._value = value
    }

    get createTimestamp(){
      return this._createTimestamp
    }
    set createTimestamp(createTimestamp){
        this._createTimestamp = createTimestamp
    }

    get enabled(){
      return this._enabled
    }
    set enabled(enabled){
        this._enabled = enabled
    }

    get updateTimestamp(){
        return this._updateTimestamp
      }
    set updateTimestamp(updateTimestamp){
        this._updateTimestamp = updateTimestamp
    }
  }